import { Col } from 'antd';
import { CustomTitle } from '@/components';

const InventoryInfoItem = ({
  label,
  value,
  span = 8, // default desktop
}: {
  label: string;
  value: number | string;
  span?: number;
}) => {
  if (!value && value !== 0) return null;

  return (
    <Col
      xs={12} // 2 per row on mobile
      sm={12} // 2 per row on small tablets
      md={span} // desktop/tablet uses provided span (8 => 3 per row)
    >
      <CustomTitle
        text={label}
        fontSize={12}
        fontWeight='600'
        lineHeight='16px'
        color='var(--text-primary)'
        marginBottom={0}
      />

      <CustomTitle
        text={value}
        fontSize={12}
        fontWeight='400'
        lineHeight='20px'
        color='var(--text-primary)'
        marginBottom={0}
        marginTop={0}
      />
    </Col>
  );
};

export default InventoryInfoItem;
